// extracted by css-extract-rspack-plugin
export default {"cls1":"UserCard-cls1_3Lh","cls2":"UserCard-cls2_lsu UserCard-cls1_3Lh"};